// ========================= IMPORT DEPENDENCIES ========================= //

import {bootstrap} from '@mvps-genesis/bootstrap';
import Global from 'pages/Global';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes to be loaded by matching the `Screen` context variable
	screenImports: {
		ABAL: () => import( './pages/account-pages/account-pages.scss' ),
		ABUS: () => import( './pages/static-pages/static-pages.scss' ),
		ACED: () => import( './pages/account-pages/account-pages.scss' ),
		ACLN: () => import( './pages/account-pages/account-pages.scss' ),
		BASK: () => import( './pages/BASK/BASK.js' ),
		CABK: () => import( './pages/account-pages/account-pages.scss' ),
		CADA: () => import( './pages/account-pages/account-pages.scss' ),
		CADE: () => import( './pages/account-pages/account-pages.scss' ),
		CEML: () => import( './pages/account-pages/account-pages.scss' ),
		CPCA: () => import( './pages/account-pages/account-pages.scss' ),
		CPCD: () => import( './pages/account-pages/account-pages.scss' ),
		CPCE: () => import( './pages/account-pages/account-pages.scss' ),
		CPWD: () => import( './pages/account-pages/account-pages.scss' ),
		CSBE: () => import( './pages/account-pages/account-pages.scss' ),
		CSUB: () => import( './pages/account-pages/account-pages.scss' ),
		CTGY: () => import( './pages/product-listing/product-listing.js' ),
		CTUS: () => import( './pages/static-pages/static-pages.scss' ),
		FAQS: () => import( './pages/static-pages/static-pages.scss' ),
		PLST: () => import( './pages/product-listing/product-listing.js' ),
		SRCH: () => import( './pages/product-listing/product-listing.js' ),
		INVC: () => import( './pages/INVC/INVC.js' ),
		OCST: () => import( './pages/OCST/OCST.js' ),
		OPAY: () => import( './pages/OPAY/OPAY.js' ),
		ORDH: () => import( './pages/account-pages/account-pages.scss' ),
		ORDS: () => import( './pages/ORDS/ORDS.js' ),
		OSEL: () => import( './pages/OSEL/OSEL.js' ),
		PATR: () => import( './pages/PROD/PROD.js' ),
		PROD: () => import( './pages/PROD/PROD.js' ),
		PRPO: () => import( './pages/static-pages/static-pages.scss' ),
		RGFT: () => import( './pages/account-pages/account-pages.scss' ),
		SARP: () => import( './pages/static-pages/static-pages.scss' ),
		SFNT: () => import( './pages/SFNT/SFNT.js' ),
		TERMS: () => import( './pages/static-pages/static-pages.scss' ),
		WISH: () => import( './pages/WISH/WISH.js' ),
		WLAD: () => import( './pages/account-pages/account-pages.scss' ),
		WLED: () => import( './pages/account-pages/account-pages.scss' ),
		WLST: () => import( './pages/account-pages/account-pages.scss' ),
		WP: () => import( './pages/WP/WP.scss' ),
		WPCK: () => import( './pages/account-pages/account-pages.scss' )
	},

	// A directory of page classes to be loaded by matching the `Page` context variable
	pageCodeImports: {},

	// Regex patterns to route to specific pages/files
	regexImports: {
		'/^UI_/': () => import( 'pages/UI_LIBRARY/UI_LIBRARY.js' )
	}

});
